import { createAsyncThunk } from '@reduxjs/toolkit';
import { getBulkUpdateData as getAutoformBulkUpdateData } from '../../services/batteries';

export const getBulkUpdateData = createAsyncThunk('getBulkUpdateData', getAutoformBulkUpdateData);
